<template>
  <form :id="id" :class="options.formClass || ''">
    <template v-for="(item, idx) in fieldsToDisplay">
      <div
        :key="idx"
        class="form-group row mb-0"
      >
        <label
          :for="item.id"
          class="col-form-label"
          :class="(options.labelClass || '') + (item.labelColsClass || '')"
          v-text="item.label"
        />

      <div
        class="border border-primary"
        :class="(options.inputClass || '') + ' ' + (item.inputColsClass || '')"
        v-if="item.html"
        v-html="item.html"
      />
      <div
        v-else
        class="border border-primary"
        :class="(options.inputClass || '') + (item.inputColsClass || '')"
      >
        <b-form-textarea
          v-if="item.isTextarea"
          readonly
          plaintext
          no-resize
          class="no-outline"
          :rows="options.rows || 5"
          :value="values[item.key]"
        />
        <input
          v-else
          type="text"
          readonly
          class="form-control-plaintext no-outline"
          :class="item.class || ''"
          :id="item.id"
          :value="values[item.key]"
          :size="item.size"
        />
        </div>
      </div>
    </template>
  </form>
</template>
<script>
export default {
  name: 'ListDetails',
  props: {
    id: {
      type: String,
      default: () => {
        const n = Date.now();
        return `formgroup_${n}`;
      },
    },
    values: {
      type: Object,
      default: () => ({}),
    },
    options: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    fieldsToDisplay() {
      const defaultLabelColsClass = 'col-xs-12 col-sm-4';
      const defaultInputColsClass = 'col-xs-12 col';
      return this.$get(this, 'options.fields', []).map((f) => {
        const classes = Array.isArray(f.modifiers) ? f.modifiers.join(' ') : f.modifiers;
        const options = this.$get(f, 'options', null);
        const setLabelColsClass = this.getColsClasses('label', options);
        const setInputColsClass = this.getColsClasses('input', options);
        return {
          ...f,
          class: classes,
          labelColsClass: setLabelColsClass || defaultLabelColsClass,
          inputColsClass: setInputColsClass || defaultInputColsClass,
        };
      });
    },
  },
  methods: {
    getColsClasses(key, options) {
      let setColsClass = '';
      if (!key) {
        return '';
      }

      if (typeof options.col === 'boolean' && options.col) {
        setColsClass += ' col';
      }
      const colSizes = ['xs', 'sm', 'md', 'lg', 'xl'];
      if (typeof options === 'object' && options) {
        // col
        setColsClass += options[`${key}Col`] ? 'col' : '';
        // col-<number>
        setColsClass += options[`${key}Cols`] ? ` col-${options[`${key}Cols`]} ` : '';
        colSizes.forEach((size, idx) => {
          const colOptName = `${key}Cols${this.$title(size)}`;
          if (options[colOptName]) {
            const colClass = `col-${size}-${options[colOptName]}`;
            setColsClass += colClass;
            if ((idx + 1) < colSizes.length) {
              setColsClass += ' ';
            }
          } else if (options[colOptName] === 0) {
            setColsClass += `col-${size}`;
            if ((idx + 1) < colSizes.length) {
              setColsClass += ' ';
            }
          }
        });
      }
      return setColsClass;
    },
  },
};
</script>
